import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { ReactComponent as SaveIcon } from "icons/save.svg";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";

const SaveSnapshotButton = () => {
  const dispatch = useDispatch();
  const { saveSnapshotDisabled } = useSelector(
    (state) => state.discovery.config
  );

  const handleSaveSnapshot = () => {
    dispatch(showModal(modalTypes.SAVE_SNAPSHOT));
  };

  return (
    <Button
      content={<SaveIcon width={15} height={15} />}
      variant={buttonVariants.borderless}
      disabled={saveSnapshotDisabled}
      classes="discovery_snapshots_controls__save_button"
      dataTestId="save-snapshot-button"
      onClick={handleSaveSnapshot}
    />
  );
};

export default SaveSnapshotButton;
